<template>
  <div>
    <table style="position: absolute;" width="100%" :height="this.windowSize.height-8"
      :max-height="this.windowSize.height-8">
      <tr max-height="48px" height="48px">


        <ContenidoBase :titulo="'Impresión de Productos más Vendidos'"
          :descripcion="'Imprime productos mas vendidos en un rango de fecha'" :EstadoBtn="EstadoBtn"
          @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="newwnuevo" @MethodGuardar="save" @MethodEliminar="remove"
          @MethodAnular="anular" @MethodImprimir="imprimirList" />
      </tr>


      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

          <div class="overflow-y-auto "
            v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn small color="yellow accent-4" @click.prevent="actualiza_tb_ver">
                      <i style="font-size: 25px;" class="fa fa-eye"> </i> ver
                    </v-btn>
                    <v-btn small dark color="deep-purple accent-2"
                      @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                      <i style="font-size: 25px;" class="fa fa-print"> </i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesConsolidadoTotal'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
              </template>
            </v-tooltip>




          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height-96">
          <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
<!-- Formulario-Productos mas Vendidos -->

            <v-container>
              <v-card color="grey lighten-3">

                <v-toolbar flat color="#BDBDBD" dense style="border: 1px solid #000000;">


                  <v-avatar tile size="45">
                    <img src="@/assets/iconos_micromarket/custom-reports.png" alt="Reporte">
                  </v-avatar>
                  <span class="font-weight-light" style="font-size: 20px;"> Impresión de Productos más Vendidos </span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
                </v-toolbar>

                <hr>

                <v-container style="border: 1px solid #000000;">
                  <v-form ref="form" @submit.prevent="" v-model="valid" lazy-validation>
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  desde  -->
                        <v-text-field hide-details dense outlined type="date" label="Desde:" :rules="[$rules.required]"
                          v-model="ProductosMasVendidos.desde" @blur="BlurDesde">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-calendar"></i>
                          </template>

                        </v-text-field>
                      </v-col>
                      <!-- fn columna 1 -->


                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">

                        <!-- -----------------------------  Hasta  -->
                        <v-text-field hide-details dense outlined type="date" :rules="[$rules.required]" label="Hasta:"
                          v-model="ProductosMasVendidos.hasta" @blur="BlurHasta">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-calendar"></i>
                          </template>
                        </v-text-field>

                      </v-col>

                    <v-col cols="12" md="12" sm="12">
                      <v-radio-group v-model="ProductosMasVendidos.opcion" class="pt-0 mt-0 d-flex justify-center " dense  hide-details row @change="changeRadioOpc">
                                  <v-radio :value="1" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">POR SUCURSAL</strong></template>
                                  </v-radio>
                                  <v-radio :value="2" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">POR SUCURSAL Y VENDEDORES</strong></template>
                                  </v-radio>
                                  <v-radio :value="3" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">POR LABORATORIO</strong></template>
                                  </v-radio>
                            </v-radio-group>
                    </v-col>

                      <v-col cols="12" md="6" sm="6">
                        <v-combobox hide-details autocomplete="off" dense outlined label="Sucursal:" :items="ListaSucursales"
                          item-text="descripcion"  v-model="ProductosMasVendidos.sucursal"
                          @focus="CargarRSucursal" @blur="SelctCbSucursal">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-users"></i>
                          </template>
                        </v-combobox>
                      </v-col>

                      <v-col v-if="ProductosMasVendidos.opcion==2" cols="12" md="6" sm="6">
                      
                        <v-combobox   hide-details v-model="ProductosMasVendidos.vendedor"
                                                :items="RVendedores"
                                                autocomplete="off"
                                                dense
                                                item-text="nombre"
                                                label="Vendedor:"
                                                outlined
                                                @focus="cargarVendedores"
                                                @blur="SelctCbVendedor"
                                              >
                                                <template v-slot:prepend>
                                                  <i class="fa fa-sign-language" style="font-size: 20px"></i>
                                                </template>
                                              </v-combobox>
                      </v-col>

                      <v-col v-if="ProductosMasVendidos.opcion==3" cols="12" md="6" sm="6">
                        <v-combobox hide-details autocomplete="off" dense outlined label="Laboratorio:" :items="RFabricante"
                          item-text="nombre" v-model="ProductosMasVendidos.fabricante"
                          @focus="CargarRFabricantes" @blur="SelctCbFabricante">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-wrench"></i>
                          </template>
                        </v-combobox>
                      </v-col>


                      <!-- fn columna 2 -->



                    </v-row>


                  </v-form>
                </v-container>

                <hr>
                <ModalReporteFiltros ref="ModRepFilt" @DataReporteBasico="DDataReporteBasico"
                  :Datos="ProductosMasVendidos" />


              </v-card>
            </v-container>
<!-- Formulario-Productos mas Vendidos -->
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir">

          <div class="overflow-y-auto "
            v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">

            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog label="myAlert" v-model="acti_tb_data" persistent max-width="100%" max-height="100%"
      transition="fab-transition">
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" @keyup="filtro" label="Buscar" single-line hide-details>
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" dense :items="list" :search="search" @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog label="myAlert" v-model="Elim_notif.estado" persistent max-width="350" transition="fab-transition">
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
          " small>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true"
      :timeout="120000" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros from "../../components/ModalReporteFiltros";
import { currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha
} from "@/js/Funciones.js";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros

  },
  created() {
    var json = {

      titulo: "Impresion de productos mas vendidos",
      descripcion: "Imprime productos mas vendidos en un rango de fecha",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      accion: [
        "ReportesProductosMasVendidosNew",
        "ReportesProductosMasVendidosSave",
        "ReportesProductosMasVendidosRemove",
        "ReportesProductosMasVendidosAnular",
        "ReportesProductosMasVendidosPrintList"
      ],
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  //mounted-cargar de inicio
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("ReportesProductosMasVendidosNew", this.new);
    // EventBus.$on("ReportesProductosMasVendidosSave", this.save);
    // EventBus.$on("ReportesProductosMasVendidosRemove", this.remove);
    // EventBus.$on("ReportesProductosMasVendidosAnular", this.remove);
    // EventBus.$on("ReportesProductosMasVendidosPrintList", this.imprimirList);
    EventBus.$on("emitReportesProductosMasVendidos", this.datostabla);
    EventBus.$on("onResize", this.onResize);

    this.$refs.ModRepFilt.CrearObjecto = this.validarObjecto;

  },
// bn mounted-cargar de inicio
  data: () => ({


    Rpropietario: [],
    RSucursal: [],
    RCaja: [],
    ListaSucursales: [],
    ListaTiposClientes: [],
    RVendedores:[],
    RFabricante: [],
    windowSize: { width: "auto", height: "auto" },
    ProductosMasVendidos: {
      nombre: 'IMPRESION DE PRODUCTOS MAS VENDIDOS',
      UrlImprimir: '/reportes-pv/ImprimirListProductosVendidos',
      UrlExel: '/reportes-pv/ExcelListProductosVendidos',
      UrlCorreo: '/reportes-pv/CorreoListProductosVendidos',
      desde: fechaNueva(),
      hasta: fechaNueva(),
      vendedor:null,
      opcion:1,
      sucursal:null,
      fabricante:null,
      //fechaCreacion: new,
      //fechaModificacion: "", 
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },





    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{ text: "Tipo Clientes", value: "descripcion" }],

    slotlist: [
      { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:"
      },
      { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
    ],

    slotHtabla: [
      { text: "Código", value: "codigo" },
      { text: "Descripcion", value: "descripcion" }
    ],

    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?"
    },

    aalert: {
      estado: false,
      color: null
    },

  }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {

  currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha,
    onResize(e) {

      console.log("imprii ")

      console.log(e)
      this.windowSize = e


    },
    // Llamar a la API y obtener los datos de la API.
    changeRadioOpc() {
      if (this.ProductosMasVendidos.opcion != 2) {
        this.ProductosMasVendidos.vendedor = null
      }
      if (this.ProductosMasVendidos.opcion != 3) {
        this.ProductosMasVendidos.fabricante = null
      }
    },
    CargarRSucursal() {

      var headers = this.$store.getters.GetheadersAxios
      this.$axios.get(this.$hostname + this.$hName + "/sucursal/findallActivos/", { headers: headers })
        .then(res => (this.ListaSucursales = res.data))
        .catch(error => console.log(error));
    },
   // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbSucursal() {

var _this = this
      setTimeout(function() {
        if (_this.ProductosMasVendidos.sucursal == null) {
          _this.ProductosMasVendidos.sucursal = ""
        }

        if (!_this.ProductosMasVendidos.sucursal.hasOwnProperty("codigo")) {
          _this.ProductosMasVendidos.sucursal = ""
          _this.ProductosMasVendidos.sucursal = null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)

    },
    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },

    datostabla(e) {

      this.ProductosMasVendidos = e;
      this.acti_tb_data = false
    },
    save() { },
    remove() { },
    eliminar() { },
    anular() { },
    imprimirList() { },
    //Retorna los objectos del componente ModalReporteFiltros
    DDataReporteBasico() { },

    // Validando el formulario y luego creando una cláusula where para una consulta.
    validarObjecto() {
      if(!this.$refs.form.validate()) {
       this.alerta("Debe seleccionar los campos en rojo","error");
       this.$refs.ModRepFilt.detener = true;
       return 
      }else{
        this.$refs.ModRepFilt.detener = false;
      }
        var adcion = ``;

     
          /*var fecdesde=this.getParamFecha(this.ProductosMasVendidos.desde)
          var fechasta=this.getParamFecha(this.ProductosMasVendidos.hasta)*/
        // new Date(this.ProductosMasVendidos.desde).toISOString().substr(0, 10)
          var fecdesde=this.ProductosMasVendidos.desde
          var fechasta=this.ProductosMasVendidos.hasta
   
        var where = ` fv.fecha >= '${fecdesde}' and fv.fecha  <='${fechasta}' `
        if (this.ProductosMasVendidos.sucursal != null) {
          adcion = ` and fv.sucursal = ${this.ProductosMasVendidos.sucursal.codigo}`;
          where += adcion;
        }


        if (this.ProductosMasVendidos.opcion == 2 && this.ProductosMasVendidos.vendedor != null) {
          where += ` and ve.codigo= ${this.ProductosMasVendidos.vendedor.codigo}`;
        }

        if (this.ProductosMasVendidos.fabricante != null
            && this.ProductosMasVendidos.fabricante.codigo != null) {
          where += ` and p.fabricante = ${this.ProductosMasVendidos.fabricante.codigo}`
        }

        
        this.ProductosMasVendidos.where = where
        
    },
    newwnuevo() {
      (this.ProductosMasVendidos = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: ""
      }),
        EventBus.$emit("actualizaBarraBusqueda2");
    },


    BlurDesde() {
      if (this.ProductosMasVendidos.desde.toString().length == 0) {
        this.ProductosMasVendidos.desde = this.fechaNueva()
      }
    },


    BlurHasta() {
      if (this.ProductosMasVendidos.hasta.toString().length == 0) {
        this.ProductosMasVendidos.hasta = this.fechaNueva()
      }
    },


    cargarVendedores() {
        let headers = this.$store.getters.GetheadersAxios
        this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findallactiv", { headers })
          .then((res) => (this.RVendedores = res.data))
      },

   // Comprobando si el valor de la entrada es nulo o indefinido.
    SelctCbVendedor() {
      var _this = this
      setTimeout(function() {
        if (_this.ProductosMasVendidos.vendedor == null) {
          _this.ProductosMasVendidos.vendedor = ""
        }

        if (!_this.ProductosMasVendidos.vendedor.hasOwnProperty("codigo")) {
          _this.ProductosMasVendidos.vendedor = ""
          _this.ProductosMasVendidos.vendedor = null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)
    },

    CargarRFabricantes() {
      var headers = this.$store.getters.GetheadersAxios
      this.$axios.get(this.$hostname + this.$hName + "/fabricante/activo", { headers: headers })
        .then(res => (this.RFabricante = res.data))
        .catch(error => console.log(error));
    },

    SelctCbFabricante() {
      var _this = this
      setTimeout(function() {
        if (_this.ProductosMasVendidos.fabricante == null) {
          _this.ProductosMasVendidos.fabricante = ""
        }

        if (!_this.ProductosMasVendidos.fabricante.hasOwnProperty("codigo")) {
          _this.ProductosMasVendidos.fabricante = ""
          _this.ProductosMasVendidos.fabricante = null
          return
        }
      }, 300)
    },



    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
      await this.$axios
        .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
          usuario: JSON.parse(JSON.stringify(this.$user))
        })
        .then(res => {
          this.list = res.data;
        });
    }
  }
};
</script>

<style>

</style>
